export const combineClasses = (...classes: (string | undefined | false)[]) =>
  classes.filter(Boolean).join(" ");

export const getInitialValues = <T extends Record<string, { defaultValue?: unknown }>>(
  config: T,
) =>
  Object.fromEntries(
    Object.entries(config).map(([key, val]) => [key, val.defaultValue]),
  );

export const saveToken = (token: string) => {
  localStorage.setItem("access_token", token);
};

export const saveRefreshToken = (token: string) => {
  localStorage.setItem("refresh_token", token);
};

export const getToken = (): string | null => localStorage.getItem("access_token");

export const getRefreshToken = (): string | null => localStorage.getItem("refresh_token");

export const clearOnLogout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
};

export const createEnum = (obj: Record<string, unknown>) => {
  Object.freeze(obj);
};

export const env = (key: keyof ImportMetaEnv, defaultValue = ""): string => {
  const value = import.meta.env[key];
  return typeof value === "string" ? value : defaultValue;
};

export const requiredMessage = (name: string) => `${name} is required`;

// react-hook-form `validate` rule: rejects a spaces-only value, which
// `required` alone lets through (it only rejects ""). Same message as
// `requiredMessage`. Pair with `.trim()` on submit.
export const notBlankValidator = (name: string) => (value: unknown) =>
  typeof value !== "string" || value.trim() !== "" || requiredMessage(name);

export const captalizeEachWord = (str?: string) => {
  if (!str) return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatText = (text: string) => {
  const value = text.replace(/_/g, " ").trim().toLowerCase();

  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const humanizeEnumValue = (value: string) => captalizeEachWord(value.replace(/_/g, " "));

interface UserData {
  email?: string;
  permissions?: string[];
  [key: string]: unknown;
}

export const getCurrentUser = (key?: keyof UserData) => {
  const data = JSON.parse(localStorage.getItem("user") || "{}") as UserData;
  if (!key) return data;
  return data[key];
};

export const checkPermission = (permission?: string) => {
  if (!permission) return true;
  const permissions = (getCurrentUser("permissions") as string[] | undefined) || [];
  return permissions.includes(permission);
};

export const formatRevenue = (amount: number) => {
  if (amount >= 10000000) {
    return `₹${(amount / 10000000).toFixed(2)} Cr`;
  }

  if (amount >= 100000) {
    return `₹${(amount / 100000).toFixed(2)} L`;
  }

  return `₹${amount.toLocaleString("en-IN")}`;
};